'use strict';

import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TrackingConstants, fetchUpdatedFilterState } from './cfs-search-slice';

import analytics from '../../../utils/analytics';

const MAX_TEXT_LENGTH = 30;

let ButtonExcerpt = ({ filter }) => {
	const dispatch = useDispatch();

	if (!filter.navigatedItem) {
		return null;
	}

	const onClick = (e) => {
		analytics.trackEvent(TrackingConstants.Categories.Removed, filter.name, TrackingConstants.Labels.Unset);

		dispatch(fetchUpdatedFilterState({
			name: filter.name,
			value: '',
			forceResultRefresh: true
		}));
	}

	const buttonText = filter.navigatedItem.displayText.length > MAX_TEXT_LENGTH
		? filter.navigatedItem.displayText.substring(0, MAX_TEXT_LENGTH) + '...'
		: filter.navigatedItem.displayText;

	return (
		<a className="navigated-filter-buttons__filter" onClick={onClick}>
			<span className="navigated-filter-buttons__filter__text">{buttonText}</span>
			<span className="navigated-filter-buttons__filter__icon icon-12x12-exit-blue"></span>
		</a>
	);
};
ButtonExcerpt = React.memo(ButtonExcerpt);

export const NavigatedFilterButtons = () => {
	const filterData = [
		{
			name: 'manufacturer',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedManufacturer)
		},
		{
			name: 'range',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedRange)
		},
		{
			name: 'model',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedModel)
		},
		{
			name: 'trim',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedTrim)
		},
		{
			name: 'derivative',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedDerivative)
		},
		{
			name: 'carType',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedCarType)
		},
		{
			name: 'gearbox',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedGearbox)
		},
		{
			name: 'fuelType',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedFuelType)
		},
		{
			name: 'mileage',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedMileage)
		},
		{
			name: 'colour',
			label: 'Colour',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedColour)
		},
		{
			name: 'numberOfDoors',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedNumberOfDoors)
		},
		{
			name: 'numberOfSeats',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedNumberOfSeats)
		},
		{
			name: 'engineSize',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedEngineSize)
		},
		{
			name: 'year',
			navigatedItem: useSelector((state) => state.cfsSearch.filterState.navigatedYear)
		},
	];

	const navigatedFilters = $.grep(filterData, (filter) => filter.navigatedItem);

	if (navigatedFilters.length === 0) {
		return null;
	}

	const content = navigatedFilters.map((filter) => (
		<ButtonExcerpt key={filter.name} filter={filter} />
	));

	return (
		<section className="navigated-filter-buttons hide-for-xxlarge">
			{content}
		</section>
	);
}